import { render, staticRenderFns } from "./activeNew.vue?vue&type=template&id=26b74661&scoped=true&"
import script from "./activeNew.vue?vue&type=script&lang=js&"
export * from "./activeNew.vue?vue&type=script&lang=js&"
import style0 from "./activeNew.vue?vue&type=style&index=0&id=26b74661&scoped=true&lang=css&"
import style1 from "./activeNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b74661",
  null
  
)

export default component.exports